@let cardClassName = actionCardStrategy.cardClassName;

@if (cardClassName) {
  <div [class]="cardClassName">
    <ng-container *ngTemplateOutlet="actionCardBody" />
  </div>
} @else {
  <ng-container *ngTemplateOutlet="actionCardBody" />
}

<ng-template #actionCardBody>
  <div class="action-card__header">
    <ocp-themed-icon [name]="iconName" [mode]="iconMode" [size]="20" />
    <span>{{ actionCardStrategy.title | translate }}</span>
  </div>
  <div class="action-card__content">
    <p>{{ actionCardStrategy.description | translate }}</p>
  </div>
  <button
    hlmBtn
    [variant]="actionCardStrategy.severity"
    size="lg"
    type="button"
    class="action-card__action-btn"
    (click)="onActionClick()"
    data-test="embedded-upload-btn"
  >
    @if (uploadButtonIconName) {
      <ocp-themed-icon
        data-icon="inline-start"
        [name]="uploadButtonIconName"
        [mode]="uploadButtonIconNameMode"
      />
    }
    {{ actionCardStrategy.buttonLabel | translate }}
  </button>
</ng-template>
